var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.subtitleLines.length)?_c('div',{staticClass:"ai-subtitles"},_vm._l((_setup.subtitleLines),function(line,index){return _c('div',{key:index},[_vm._v(_vm._s(line))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }